export const environment = {
  PRODUCTION: false,
  AUTH0: {
    DOMAIN: "dev-e6kqvvjgoc3fns44.us.auth0.com",
    CLIENT_ID: "9cFOmHYtBjjXAh1W9iyMd0fweRSC79Sj",
  },
  AUTOSYNC: {
    API_URL: "https://apis.rmfarma.io/autosync",
    TOKEN: "AIzaSyC5Gf_ExwpyM67sngWobRiOuh9Shqtc7As",
  },
  PHARMA_DASH_API_URL: "https://apis-dev.rmfarma.io/saas/pharma-dash",
  AHRI_API_URL: "https://ahri-api-dev-770224442615.us-central1.run.app",
};
